import React from "react";
import Types from "prop-types";
import LanguageSelector from "../../LanguageSelector";
import TryAnotherWayImg from "../../../images/try-another-way.svg";
import CardImg from "../../../images/Wallet-balance.svg";
import { ReCaptcha } from "../../Guard";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import Analytika from "../../../analytika";
import eventAnalytics from "../../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../../utils/constants";
import VerificationInput from "react-verification-input";
import { loadSheild } from "../../../sheild";

export class VerifyCardLoginForm extends React.Component {
  constructor(props) {
    super(props);

    loadSheild();
    eventAnalytics.setPageName(ANALYTIKA_EVENTS.PAGE.VERIFY__CARD_FORM_VIEW);
    eventAnalytics.publishV2(
      ANALYTIKA_EVENTS.IDNW_VIEW_PAGE.event_name,
      ANALYTIKA_EVENTS.IDNW_VIEW_PAGE.event_version,
      ANALYTIKA_EVENTS.IDNW_VIEW_PAGE.signature,
      {
        page_name: ANALYTIKA_EVENTS.PAGE.VERIFY__CARD_FORM_VIEW,
      }
    );
    Analytika.fireEvent("Idtn_Web_CardLogin_View", {
      phonenumber: props.fullPhoneNumber,
    });
    this.onCardPinChange = props.onCardPinChange;
    this.onTryAnotherClickHandler = props.onTryAnotherClickHandler;
    this.isTryAnotherWayVisible = props.isTryAnotherWayVisible;
    this.onSubmit = props.onSubmit;

    this.createAccount = props.createAccount;
  }

  render() {
    return this.renderClassic();
  }

  renderClassic() {
    const { t, error, submitting } = this.props;

    return (
      <form data-request-type="card_submit" onSubmit={this.onSubmit}>
        <Helmet>
          <title>Verify Card | Careem</title>
        </Helmet>

        <div className="help-lang-container">
          <LanguageSelector />
        </div>
        <h1>{t("login:verify__card_title")}</h1>

        {error && <div className="invalid show">{error}</div>}

        <div className="card-img-container">
          <img src={CardImg} alt="CardImg" width="256px" height="158px" />
        </div>
        <div className="verify-card-hint">{t("login:lbl_verify_card")}</div>

        <VerificationInput
          length={4}
          placeholder=""
          passwordMode={true}
          classNames={{
            container: "pin-container",
            character: "pin-character",
            characterSelected: "pin-selected",
          }}
          onChange={this.onCardPinChange}
        />

        {this.isTryAnotherWayVisible && (
          <div
            className="btn-try-another-way"
            name="btn-try-another-way"
            onClick={this.onTryAnotherClickHandler}
          >
            <img src={TryAnotherWayImg} alt="TryAnotherWayImg" width="20px" />
            {t("login:try-another-way")}
          </div>
        )}

        <input
          className="btn-careem"
          type="submit"
          value={submitting ? t("common:please_wait") : t("common:continue")}
          name="btn-verify-card"
          disabled={submitting}
        />
        <input
          className="btn-careem-tertiary"
          type="button"
          value={t("login:create_account")}
          name="btn-create-account"
          onClick={this.createAccount}
        />

        <ReCaptcha />
      </form>
    );
  }
}

VerifyCardLoginForm.propTypes = {
  t: Types.func.isRequired,
  onCardPinChange: Types.func.isRequired,
  onTryAnotherClickHandler: Types.func.isRequired,
  isTryAnotherWayVisible: Types.bool.isRequired,
  createAccount: Types.func.isRequired,
  onSubmit: Types.func.isRequired,
  fullPhoneNumber: Types.string,
  error: Types.string,
  submitting: Types.bool,
};
export default withTranslation()(VerifyCardLoginForm);
